import { __decorate } from "tslib";
import { Action, Getter, Mutation, State } from "@/types";
import { service } from "@/services";
export class AccessSchedulesModule {
    constructor() {
        this.accessSchedules = [];
        this.count = 0;
        this.axiosError = null;
    }
    setItems(accessSchedules) {
        this.accessSchedules = accessSchedules;
    }
    setTotal(count) {
        this.count = count;
    }
    setError(error) {
        this.axiosError = error;
    }
    get list() {
        return this.accessSchedules;
    }
    get total() {
        return this.count;
    }
    get errorList() {
        return this.axiosError;
    }
    async get(options) {
        try {
            const data = await service.accessSchedules.get(options);
            this.setItems(data.items);
            this.setTotal(data.total);
        }
        catch (error) {
            this.setError(error);
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
    async add(accessSchedules) {
        try {
            await service.accessSchedules.add(accessSchedules);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
        }
    }
    async edit(accessSchedules) {
        try {
            await service.accessSchedules.edit(accessSchedules);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
    async delete(accessScheduleId) {
        try {
            await service.accessSchedules.delete(accessScheduleId);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
}
__decorate([
    State()
], AccessSchedulesModule.prototype, "accessSchedules", void 0);
__decorate([
    State()
], AccessSchedulesModule.prototype, "count", void 0);
__decorate([
    State()
], AccessSchedulesModule.prototype, "axiosError", void 0);
__decorate([
    Mutation()
], AccessSchedulesModule.prototype, "setItems", null);
__decorate([
    Mutation()
], AccessSchedulesModule.prototype, "setTotal", null);
__decorate([
    Mutation()
], AccessSchedulesModule.prototype, "setError", null);
__decorate([
    Getter()
], AccessSchedulesModule.prototype, "list", null);
__decorate([
    Getter()
], AccessSchedulesModule.prototype, "total", null);
__decorate([
    Getter()
], AccessSchedulesModule.prototype, "errorList", null);
__decorate([
    Action()
], AccessSchedulesModule.prototype, "get", null);
__decorate([
    Action()
], AccessSchedulesModule.prototype, "add", null);
__decorate([
    Action()
], AccessSchedulesModule.prototype, "edit", null);
__decorate([
    Action()
], AccessSchedulesModule.prototype, "delete", null);
